import {ITheme} from 'contexts/ThemeContext';
import {StyleSheet} from 'react-native';

export default (props: ITheme) => {
  return StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: props.colors.dirtyWhite,
      alignItems: 'center',
    },

    imageAndTextContainer: {
      flex: 1,
    },

    imageContainer: {
      width: 92,
      height: 92,
    },

    avatarImage: {
      width: 92,
      height: 92,
      borderRadius: 60,
    },

    textStyle: {
      marginTop: 36,
      fontSize: 20,
      color: props.colors.black,
      ...props.typography.notoSansMedium,
    },
    penContainer: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      backgroundColor: props.colors.cornflowerBlue,
      width: 28,
      height: 28,
      borderRadius: 60,
      justifyContent: 'center',
      alignItems: 'center',
    },
    penSize: {
      width: 13,
      height: 13,
    },
  });
};
